export default __webpack_public_path__ + "static/status-updated-ecc14f031d1baa31b78f6949a7c4db10.svg";